<template>
    <center-layout>
        <h2 class="pb-4">
            Welcome to Diario. Please sign in or
            <router-link to="/signup">sign up</router-link> to get started.
        </h2>

        <v-alert type="error" v-if="error" v-text="error" />
        <v-form>
            <v-text-field v-model="email" type="email" label="Email" outlined />
            <v-text-field
                v-model="password"
                label="Password"
                :append-icon="show_password ? 'mdi-eye' : 'mdi-eye-off'"
                :type="show_password ? 'text' : 'password'"
                @click:append="show_password = !show_password"
                outlined
            />
            <v-btn block color="primary" @click="signin">
                Sign In
            </v-btn>
        </v-form>
    </center-layout>
</template>

<script>
import firebase from "firebase";
import CenterLayout from "../components/CenterLayout.vue";

export default {
    name: "Signin",
    components: { CenterLayout },
    data: function() {
        return {
            email: "",
            password: "",
            show_password: false,
            error: false
        };
    },
    mounted() {
        if (this.$route.query.redirected_from) {
            this.error = `You must sign in before accessing ${this.$route.query.redirected_from}`;
        }
    },
    methods: {
        signin: function() {
            firebase
                .auth()
                .signInWithEmailAndPassword(this.email, this.password)
                .then(() => {
                    setTimeout(() => {
                        this.$router.replace({ name: "Entries" });
                    }, 750);
                })
                .catch(error => {
                    this.error = error.message;
                });
        }
    }
};
</script>
